<template lang="pug">
    .login
        Layout
            Content(:style="loginPageContentStyle")
                div(:style="backgroundLogoStyle")
                    Card.loginCard(dis-hover)
                        img(:src="loginImgs.signupByInviteFormLogoImgName" style="min-width:300px;max-width: 350px")
                        Divider
                        p.signup-description {{ loginDescription }}
                        p.signup-description Hi, {{ tokenDecrypt.username }},
                        p.signup-description {{ tokenDecrypt.inviterName }} has invited you
                        // p {{ tokenDecrypt }}
                        Form.loginInput(
                            ref="signupByInviteForm",
                            :model="signupByInviteForm",
                            :rules="loginRules"
                        )
                            FormItem(prop="username")
                                Input(
                                    :disabled="true"
                                    @on-enter="handleSubmit"
                                    type="text"
                                    v-model="tokenDecrypt.username"
                                    placeholder="Username"
                                    suffix="md-person"
                                    
                                )
                            FormItem(prop="password")
                                Input(
                                    @on-enter="handleSubmit"
                                    type="password"
                                    password
                                    v-model="signupByInviteForm.password"
                                    placeholder="Password"
                                )
                            FormItem
                                Button.loginBtn(@click="handleSubmit") Signup
            Modal(
                title="Success"
                v-model="isSignupSuccessModalShow"
            )
                p This is your login OTP QRCode
                p Make sure you scan the QRCode before you leave this page
                    img(:src="otpBase64Img")
                div(slot="footer")
                        Button(@click="$router.push({name: 'login'})" type="primary" long) Go to portal
</template>
<script>
import { _login } from "@/api/user";
import { getUserData } from "@/api/user";
import { validateInvitationToken, signupByInvite } from "@/api/user";

export default {
    name: "SignupInvite",
    data() {
        return {
            signupByInviteForm: {
                username: "",
                password: ""
            },
            loginRules: {
                // username: [
                //     {
                //         required: true,
                //         message: "Please fill in the user name",
                //         trigger: "change",
                //     },
                // ],
                password: [
                    {
                        required: true,
                        message: "Please fill in the password.",
                        trigger: "change"
                    }
                ]
            },
            tokenDecrypt: {
                username: "",
                inviterName: "",
                groupName: "",
            },
            isSignupSuccessModalShow: false,
            otpBase64Img: ""
        };
    },
    created() {},
    mounted() {
        let { token, taskNo } = this.$route.query;
        if (token == undefined || taskNo == undefined) {
            this.$router.push({ name: "login" });
        }
        console.log(token);
        validateInvitationToken({ token, taskNo })
            .then(res => {
                if (!res.data.success) throw new Error("");

                if (res.data.data.userExist) {
                    this.$router.push({ name: "login" });
                }

                this.tokenDecrypt = res.data.data.tokenDecrypt;
            })
            .catch(err => {
                console.log(err);
                this.$router.push({ name: "login" });
            });
    },
    methods: {
        handleSubmit() {
            this.$refs.signupByInviteForm.validate(valid => {
                if (!valid) return;
                let { token, taskNo } = this.$route.query;
                signupByInvite({ token, taskNo, password: this.signupByInviteForm.password })
                    .then(res => {
                        if (res.data.success !== true)
                            throw new Error(res.data.message);

                        this.otpBase64Img = res.data.data.base64Img;
                        this.isSignupSuccessModalShow = true;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            });
        }
        // async login(e) {
        //     try {
        //         await _login(this.signupByInviteForm);

        //         let userDataResult = await getUserData();
        //         let userData = userDataResult.data;
        //         this.$store.commit("SET_USER_DATA", userData);
        //         this.$router.push({ path: this.homePath });
        //     } catch (err) {
        //         console.log(err);
        //         this.$Message.error("帳號或密碼有誤");
        //     }
        // },
    },
    computed: {
        loginDescription: function() {
            return this.$store.getters.getLoginDescription;
        },
        loginImgs: function() {
            return this.$store.getters.getLoginPageImgs;
        },
        loginPageContentStyle() {
            return {
                background: `url(${this.loginImgs.backgroundImgName}) no-repeat center center`,
                overflow: "hidden",
                "background-size": "cover",
                "background-color": this.$store.getters["getBrandName"] == "A8CDN" ? "rgba(0, 0, 0, 0.4)" : "",
                "background-blend-mode": this.$store.getters["getBrandName"] == "A8CDN" ? "multiply" : "",
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
            };
        },
        backgroundLogoStyle() {
            return {
                width: "100vw",
                height: "100vh",
                background: `url(${this.loginImgs.backgroundLogoImgName}) no-repeat center center`,
                "background-size": "auto 90%",
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
            };
        }
    }
};
</script>
<style scoped>
.loginCard {
    background: transparent;
    border: none;
    text-align: center;
}
.ivu-input-wrapper >>> .ivu-input-suffix {
    padding-right: 15px;
}

.ivu-input-wrapper >>> .ivu-input-suffix i {
    line-height: 40px;
}
.signup-description {
    font-size: 28px;
    color: #fff;
    margin-bottom: 24px;
}
@media screen and (min-width: 1280px) {
    .signup-description {
        font-size: 28px;
    }
}
@media (max-width: 1080px) and (min-width: 960px) {
    .signup-description {
        font-size: 24px;
    }
}
@media screen and (max-width: 960px) {
    .signup-description {
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/general/SignupInvite.vue